export { default } from './SearchPerson'
